import React from 'react';
import { Clock, Award, Zap, BadgeDollarSign, ShieldCheck } from 'lucide-react';
export function ValueProposition() {
  return <section className="py-16 bg-[#F8F9FA]" data-id="element-425">
      <div className="container mx-auto px-4" data-id="element-426">
        <div className="text-center mb-12" data-id="element-427">
          <div className="flex justify-center mb-4" data-id="element-428">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10" data-id="element-429" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D] mb-4" data-id="element-430">
            Why 9 Out of 10 Real Estate Agents Recommend Crown Inspection
            Services
          </h2>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-431">
            With over 15 years of experience in Southwest Florida, we provide
            thorough inspections, detailed reports, and exceptional service that
            both buyers and agents trust.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-432">
          <ValueCard icon={<Award size={32} className="text-[#D4AF37]" data-id="element-434" />} title="15+ Years Local Experience" description="Deep knowledge of Southwest Florida's unique building challenges and common issues." data-id="element-433" />
          <ValueCard icon={<Clock size={32} className="text-[#D4AF37]" data-id="element-436" />} title="Same-Day Detailed Reports" description="Receive your comprehensive inspection report with photos within hours, not days." data-id="element-435" />
          <ValueCard icon={<Zap size={32} className="text-[#D4AF37]" data-id="element-438" />} title="Latest Inspection Technology" description="Thermal imaging and moisture detection included with every inspection at no extra cost." data-id="element-437" />
          <ValueCard icon={<BadgeDollarSign size={32} className="text-[#D4AF37]" data-id="element-440" />} title="Insurance Discounts Up To 40%" description="Our wind mitigations inspections may help homeowners save thousands on insurance premiums." data-id="element-439" />
          <ValueCard icon={<ShieldCheck size={32} className="text-[#D4AF37]" data-id="element-442" />} title="Certified Professionals" description="Our team consists of fully licensed and certified inspectors with extensive training and experience." data-id="element-441" />
          <div className="bg-[#1B365D] text-white rounded-lg p-6 shadow-lg flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300" data-id="element-443">
            <div className="text-[#D4AF37] text-5xl font-bold mb-2" data-id="element-444">1000's</div>
            <div className="text-xl font-semibold mb-2" data-id="element-445">
              of satisfied customers
            </div>
            <p className="text-gray-200" data-id="element-446">
              Join hundreds of satisfied homeowners who trust Crown Inspection
              Services for their most important investment.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
interface ValueCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
function ValueCard({
  icon,
  title,
  description
}: ValueCardProps) {
  return <div className="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300" data-id="element-447">
      <div className="mb-4" data-id="element-448">{icon}</div>
      <h3 className="text-xl font-bold text-[#1B365D] mb-2" data-id="element-449">{title}</h3>
      <p className="text-[#2C3E50]" data-id="element-450">{description}</p>
    </div>;
}